<script lang="ts">
    import type ServiceProvider from '../services/service.provider'
    import type { Document } from '../interfaces/document.interface'
    import { ymdToDmy } from '../../../core/utils/date.util'
    import Pager from './Pager.svelte'

    export let serviceProvider: ServiceProvider

    let documentList: Document[] = []
    let total = 0
    let error = false
    let processing = false
    let isFilterActive = false

    serviceProvider.documentService.listSubs.subscribe((list) => {
        documentList = list
        window.scrollTo({ top: 0, behavior: "smooth" })
    })
    serviceProvider.documentService.totalSubs.subscribe((number) => (total = number))
    serviceProvider.documentService.errorSubs.subscribe((status) => (error = status))
    serviceProvider.documentService.processingSubs.subscribe((status) => (processing = status))
    serviceProvider.documentService.isFilterActiveSubs.subscribe((isActive) => (isFilterActive = isActive))
</script>

{#if processing}
    <h2>Vyhledávám...</h2>
{:else if error}
    <h2>Výsledky vyhledávání</h2>
    <p>Nastala chyba při vyhledávání</p>
{:else}
    {#if isFilterActive}
        <h2>Výsledky {total} vyhledávání</h2>
    {:else}
        <p>Pro vyhledání dokumentu prosím zvolte typ dokumentu nebo napište text do vyhledávacího pole.</p>
        <h2>Nejnovější dokumenty</h2>
    {/if}

    {#if Array.isArray(documentList) && documentList.length}
        <div class="bno-search-list">
            <ul class="bno-search-list__items">
                {#each documentList as item}
                    <li class="bno-search-list__item bno-search-list__item--variant-b">
                        <h4>
                            {#if item.extension}
                                <span class="bno-icon bno-icon--{item.extension.toLowerCase() === 'pdf' ? 'pdf' : 'doc'}" aria-hidden="true"></span>
                            {/if}
                            <a
                                href={item.url}
                                target="{item.extension ? '_blank' : ''}"
                                class="{item.extension ? 'bno-link--without-external-icon' : ''}"
                                aria-label={item.title}
                            >
                                {item.title}
                            </a>
                            {#if item.extension}
                                <span>({item.extension}, {item.size})</span>
                            {/if}
                        </h4>

                        {#if item.description}
                            {@html item.description}
                        {/if}

                        {#if item.ucinnostOd || item.ucinnostDo}
                            <p class="bno-search-list__efficiency">
                                <span class:bno-search-list__efficiency--red="{item.platnostOd === false}">
                                    {#if item.platnostOd === false}
                                        <span class="bno-icon bno-icon--warning bno-icon--16x16" style="color: var(--smb-warning-300);" aria-hidden="true"></span>
                                    {/if}
                                    Účinnost od
                                    {#if item.ucinnostOd}
                                        <strong>
                                            {ymdToDmy(item.ucinnostOd)}
                                        </strong>
                                    {:else}
                                        <strong style="color: #878787;">nezadána</strong>
                                    {/if}
                                </span>

                                {#if item.ucinnostDo}
                                    <span class:bno-search-list__efficiency--red="{item.platnostDo === false}">
                                        {#if item.platnostDo === false}
                                            <span class="bno-icon bno-icon--warning bno-icon--16x16" style="color: var(--smb-warning-300);" aria-hidden="true"></span>
                                        {/if}
                                        Účinnost do
                                        <strong>
                                            {ymdToDmy(item.ucinnostDo)}
                                        </strong>
                                    </span>
                                {/if}
                            </p>
                        {/if}

                        {#if item.breadcrumbs}
                            {@html item.breadcrumbs}
                        {/if}
                    </li>
                {/each}
            </ul>
        </div>
        {#if isFilterActive}
            <Pager {serviceProvider}/>
        {/if}
    {:else}
        <p>Vašemu zadání neodpovídají žádné výsledky</p>
    {/if}
{/if}
